import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {

    Facebook,
    Youtube,
    Instagram,
} from 'lucide-react';
import logoNeoAI from '../assets/Asset 4.svg'; // Optimized Vector Logo

// Custom TikTok Icon
const TiktokIcon = ({ size = 24, className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
    >
        <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
    </svg>
);

const Footer = () => {
    const { t } = useTranslation();

    return (
        <footer className="relative z-50 bg-[#0b1c2d] text-slate-300 pt-10 pb-6 border-t border-slate-800">
            <div className="max-w-7xl mx-auto px-6">
                <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">

                    {/* COLUMN 1: BRAND */}
                    <div className="col-span-2 lg:col-span-2">
                        <Link to="/" className="flex items-center gap-2 mb-3">
                            <img src={logoNeoAI} alt="Neo AI Logo" className="h-14 w-auto object-contain" />
                        </Link>
                        <p className="text-sm text-slate-400 leading-relaxed mb-4 max-w-sm">
                            {t('footer.desc')}
                        </p>
                    </div>

                    {/* COLUMN 2: PRODUCT */}
                    <div>
                        <h3 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">{t('footer.product')}</h3>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/#features" className="hover:text-[#2299ED] transition-colors">{t('footer.features')}</Link></li>
                            <li><Link to="/pricing" className="hover:text-[#2299ED] transition-colors">{t('footer.pricing')}</Link></li>
                            <li><Link to="/showcase" className="hover:text-[#2299ED] transition-colors">{t('footer.showcase')}</Link></li>
                        </ul>
                    </div>

                    {/* COLUMN 3: SITEMAPS */}
                    <div>
                        <h3 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">{t('footer.sitemaps')}</h3>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/" className="hover:text-[#2299ED] transition-colors">{t('footer.home')}</Link></li>
                            <li><Link to="/about" className="hover:text-[#2299ED] transition-colors">{t('footer.about')}</Link></li>
                            <li><Link to="/blog" className="hover:text-[#2299ED] transition-colors">{t('footer.blog')}</Link></li>
                            <li><Link to="/contact" className="hover:text-[#2299ED] transition-colors">{t('footer.contact')}</Link></li>
                        </ul>
                    </div>

                    {/* COLUMN 4: CONNECT */}
                    <div>
                        <h3 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">{t('footer.connect')}</h3>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <a href="https://www.facebook.com/profile.php?id=61560199275289" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[#2299ED] transition-colors">
                                    <Facebook size={16} /> <span>Facebook</span>
                                </a>
                            </li>
                            <li>
                                <a href="https://youtube.com/@neoai24?si=Gjx3SfXxA2eMWs0p" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[#2299ED] transition-colors">
                                    <Youtube size={16} /> <span>YouTube</span>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/neo.ai_" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[#2299ED] transition-colors">
                                    <Instagram size={16} /> <span>Instagram</span>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.tiktok.com/@neo.ai_" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[#2299ED] transition-colors">
                                    <TiktokIcon size={16} /> <span>TikTok</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                </div>

                {/* BOTTOM BAR */}
                <div className="pt-6 border-t border-slate-800 flex flex-col md:flex-row items-center justify-center gap-4">
                    <div className="text-sm text-slate-400 text-center">
                        &copy; {new Date().getFullYear()} Neo AI. {t('footer.rights')}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
